import { gql } from '@apollo/client';

export const QUERY_ASSETS = gql`
  query assets {
    pets {
      id
      code
      name
      parentObject {
        id
        code
        name
      }
    }
    petSizes {
      id
      code
      name
    }
    props {
      id
      code
      name
      parentObject {
        id
        code
        name
      }
    }
    wardrobes {
      id
      code
      name
      parentObject {
        id
        code
        name
      }
    }
    sportEquipments {
      id
      code
      name
      parentObject {
        id
        code
        name
      }
    }
  }
`;
